import { useTranslation } from 'react-i18next'
import { useSpheraOptions } from '@/api/queries/sphera-export-queries'
import { Field, FieldContent, FieldLabel } from '@/components/ui/field'
import { NativeSelect, NativeSelectOption } from '@/components/ui/native-select'

interface SpheraFlagSelectProps {
	value: string
	onChange: (value: string) => void
}

/** Flag do Sphera (Events: Flags Categories) usada na exportação para o Sphera. */
export function SpheraFlagSelect({ value, onChange }: SpheraFlagSelectProps) {
	const { t } = useTranslation()
	const { data } = useSpheraOptions()

	return (
		<Field>
			<FieldLabel htmlFor="sphera-flag">
				{t('administration.spheraName.label')}
			</FieldLabel>
			<FieldContent>
				<NativeSelect
					id="sphera-flag"
					value={value}
					onChange={(e) => onChange(e.target.value)}
				>
					<NativeSelectOption value="">
						{t('administration.spheraName.none')}
					</NativeSelectOption>
					{(data?.flags ?? []).map((flag) => (
						<NativeSelectOption key={flag.id} value={flag.name}>
							{flag.name}
						</NativeSelectOption>
					))}
				</NativeSelect>
			</FieldContent>
		</Field>
	)
}
